import React from 'react';
import Button from '../Button/Button';
import ImageWebp from '../ImageWebp/ImageWebp';
import './Footer.scss';

const Footer = () => (
  <footer className="footer-main">
    <div className="container">
      <div className="row">
        <div className="col-md col-4">
          <div className="footer-logo">
            {/* <LogoAnim /> */}
            <ImageWebp
              srcWebp="https://ftx-rp.netlify.app/img/ftx21.webp"
              src="https://ftx-rp.netlify.app/img/ftx21.png"
              alt=""
              loading="lazy"
              className="logo"
            />

            <p>The Ultimate FinTech Conference for Disruptors</p>
          </div>
        </div>

        <div className="col-md col-7 offset-1">
          <div className="footer-social-block">
            <h3>SHARE VIA</h3>

            <div className="footer-social">
              <a
                className="single-social"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Frazorpay.com%2Fftx">
                <ImageWebp
                  srcWebp="https://ftx-rp.netlify.app/img/social-border.webp"
                  src="https://ftx-rp.netlify.app/img/social-border.png"
                  alt=""
                  loading="lazy"
                />
                <svg width="12" height="26" fill="none" viewBox="0 0 12 26">
                  <path
                    fill="url(#paint0_linear_1136:553)"
                    d="M11.444 12.823H7.852v12.802H2.53V12.823H0V8.298h2.53V5.371C2.53 3.275 3.526 0 7.901 0l3.944.015v4.392H8.983c-.466 0-1.129.233-1.129 1.233v2.659h4.055l-.465 4.524Z"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1136:553"
                      x1="19.5"
                      x2="32.946"
                      y1="38"
                      y2="25.534"
                      gradientUnits="userSpaceOnUse">
                      <stop className="stop-1" />
                      <stop offset="1" className="stop-2" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                className="single-social"
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/intent/tweet?url=https%3A%2F%2Frazorpay.com%2Fftx&text=India%E2%80%99s%20biggest%20fintech%20conference%20is%20back!%2010%2C000%20attendees%2C%20100%20speakers%2C%20and%2050%20sessions%20for%20your%20business%20this%20December%209-10!%20Book%20your%20tickets%20now.%20%23FTX21">
                <ImageWebp
                  srcWebp="https://ftx-rp.netlify.app/img/social-border.webp"
                  src="https://ftx-rp.netlify.app/img/social-border.png"
                  alt=""
                  loading="lazy"
                />
                <svg width="26" height="21" fill="none" viewBox="0 0 26 21">
                  <path
                    fill="url(#paint0_linear_1136:475)"
                    d="M25.5 2.486a10.33 10.33 0 0 1-3.005.834 5.305 5.305 0 0 0 2.3-2.933 10.39 10.39 0 0 1-3.321 1.287A5.195 5.195 0 0 0 17.654 0c-2.889 0-5.232 2.374-5.232 5.301 0 .416.047.82.136 1.209C8.21 6.289 4.355 4.178 1.775.97a5.333 5.333 0 0 0-.709 2.665 5.32 5.32 0 0 0 2.328 4.413 5.143 5.143 0 0 1-2.37-.664v.068c0 2.568 1.804 4.71 4.197 5.197a5.148 5.148 0 0 1-2.363.092c.666 2.106 2.598 3.639 4.887 3.682A10.409 10.409 0 0 1 0 18.618 14.657 14.657 0 0 0 8.019 21c9.623 0 14.885-8.078 14.885-15.085 0-.23-.005-.458-.015-.685A10.688 10.688 0 0 0 25.5 2.486Z"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1136:475"
                      x1="41.753"
                      x2="49.548"
                      y1="31.142"
                      y2="12.259"
                      gradientUnits="userSpaceOnUse">
                      <stop className="stop-1" />
                      <stop offset="1" className="stop-2" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                className="single-social"
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Frazorpay.com%2Fftx&title=India%E2%80%99s%20biggest%20fintech%20conference%20is%20back!%2010%2C000%20attendees%2C%20100%20speakers%2C%20and%2050%20sessions%20for%20your%20business%20this%20December%209-10!%20Book%20your%20tickets%20now.%20%23FTX21">
                <ImageWebp
                  srcWebp="https://ftx-rp.netlify.app/img/social-border.webp"
                  src="https://ftx-rp.netlify.app/img/social-border.png"
                  alt=""
                  loading="lazy"
                />
                <svg width="26" height="24" fill="none" viewBox="0 0 26 24">
                  <path
                    fill="url(#paint0_linear_841:20990)"
                    d="M.027 24h5.091V6.86H.028V24ZM19.86 6.268c-2.47 0-4.681.911-6.25 2.923V6.805H8.502V24h5.11v-9.299c0-1.965 1.782-3.882 4.015-3.882 2.233 0 2.783 1.917 2.783 3.834v9.345H25.5v-9.727c0-6.757-3.167-8.003-5.64-8.003ZM2.55 5.148c1.407 0 2.549-1.153 2.549-2.574C5.098 1.154 3.956 0 2.548 0 1.143 0 0 1.153 0 2.574 0 3.996 1.142 5.15 2.549 5.15Z"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_841:20990"
                      x1="41.753"
                      x2="51.499"
                      y1="35.59"
                      y2="14.931"
                      gradientUnits="userSpaceOnUse">
                      <stop className="stop-1" />
                      <stop offset="1" className="stop-2" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                className="single-social"
                target="_blank"
                rel="noopener noreferrer"
                href="https://instagram.com/razorpay">
                <ImageWebp
                  srcWebp="https://ftx-rp.netlify.app/img/social-border.webp"
                  src="https://ftx-rp.netlify.app/img/social-border.png"
                  alt=""
                  loading="lazy"
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="url(#paint0_linear_1628_496)"
                    fillRule="evenodd"
                    d="M20 0H4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm2 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16ZM12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm8-10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                    clipRule="evenodd"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1628_496"
                      x1="39.297"
                      x2="49.415"
                      y1="35.59"
                      y2="15.405"
                      gradientUnits="userSpaceOnUse">
                      <stop className="stop-1" />
                      <stop offset="1" className="stop-2" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <Button primary href="mailto:ftx@razorpay.com">
                ftx@razorpay.com
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
